var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen",attrs:{"id":"app"}},[_c('nav'),(!_vm.loading)?_c('div',{ref:"mainContainer",staticClass:"h-full"},[_c('router-view',{attrs:{"bgColor":_vm.randomBg,"textColor":_vm.randomText}})],1):_c('div',[_c('div',{staticClass:"espera"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }